$(function () {

	var setButtonHandler = function(evt) {
		
		if (evt.which === 32 || evt.which === 13) {
			evt.preventDefault();
			evt.target.click();
		}
	};

	function initButtonHandler() {
		$(document).on('keydown', 'button.button-collapsible', $.proxy(function(evt) {
			setButtonHandler(evt);
		}, this));
	}

	initButtonHandler();
});
